import React, { useContext, useState, useEffect, useMemo } from "react";

import { Icon, ImageEditor, ModalDialog, PlainButton } from "@culturehq/components";

import { Trans } from "app/utils";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import ChqModalDialog from "components/common/ChqModalDialog";

const ThumbnailImage: React.FC<{}> = () => {
  const { data, handleAutosaveDraft } = useContext(CreatomateContext);
  const { selectedThumbnail, selectedMediaVersion, story } = data;

  const [loading, setLoading] = useState(true);
  const [isCropperOpen, setIsCropperOpen] = useState(false);

  const thumbUrl = useMemo(() => {
    if (typeof selectedThumbnail === "string" && selectedThumbnail.startsWith("http")) {
      return selectedThumbnail;
    }
    if (selectedThumbnail instanceof Blob) {
      return URL.createObjectURL(selectedThumbnail);
    }
    return selectedMediaVersion?.thumbnail || story?.media?.thumbnail || story?.thumbnail || null;
  }, [selectedThumbnail, selectedMediaVersion, story]);

  useEffect(() => (
    () => {
      if (selectedThumbnail instanceof Blob && thumbUrl) URL.revokeObjectURL(thumbUrl);
    }
  ), [selectedThumbnail, thumbUrl]);

  const handleCroppedImage = (image: Blob) => {
    // Revoke the old URL before creating a new one
    if (selectedThumbnail instanceof Blob && thumbUrl) {
      URL.revokeObjectURL(thumbUrl);
    }
    handleAutosaveDraft({ selectedThumbnail: image });
    setIsCropperOpen(false);
  };

  const handleCropClose = () => {
    setIsCropperOpen(false);
  };

  return (
    <div>
      <div className="upload-image">
        <div className="text-image">
          <p>
            <Trans>
              You can upload your own image
              {story && " or select a thumbnail from the video"}
            </Trans>
          </p>
        </div>
        <div className="thumbnail-selection">
          <img
            className="show-image"
            src={thumbUrl || ""}
            alt={story?.question?.question || ""}
            onLoad={() => setLoading(false)}
          />
          {!loading && (
            <div className="Image-Crop">
              <PlainButton onClick={() => setIsCropperOpen(true)}>
                <Icon icon="crop" />
              </PlainButton>
              {isCropperOpen && (
                <ChqModalDialog onClose={handleCropClose}>
                  <ModalDialog.Body>
                    <ImageEditor
                      image={thumbUrl}
                      onEdit={handleCroppedImage}
                    />
                  </ModalDialog.Body>
                </ChqModalDialog>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThumbnailImage;
